<template>
    <div class="section">
        <div class="container section-koe" :class="{'full' : pagename == 'about'}">
            <h4 v-if="pagename !== 'about'">管理栄養士・栄養士が提案する<br class="hidePc">「予防めし」</h4>
            <div class="col">
                <div class="logo-wrap">
                    <LogoYobo class="logo" />
                    <TextYobo class="word" />
                </div>
                <div class="text-box">
                    <span class="caption" v-if="pagename !== 'about'">
                        THEME
                    </span>
                    <span class="caption for-about" v-if="pagename == 'about'">
                        2020年夏のテーマは
                    </span>
                    <h5>
                        免疫機能を低下<br class="hidePc">させないで<br>
                        感染症の予防に<br class="hidePc">役立つ食事
                    </h5>
                </div>
            </div>
            <p v-if="pagename == 'recipe'">
              2020年夏の「予防めし」は、<br class="hidePc">継続して適正な食生活を送るための<br class="hidePc">一助となるような<br class="hideSp">
              日々の食事例を<br class="hidePc">具体的に伝えることを目的に、<br class="hidePc">管理栄養士・栄養士が<br class="hidePc">自慢のレシピと食事を提案します。
            </p>
            <p class="left" v-if="pagename == 'about'">
                免疫機能は、多様な成分が複雑な代謝を営むことによって成りたち、その仕組みには、多くの種類の栄養素が関与していることが分ってきました。<br><br class="hidePc">
                食事からとる多くの成分が総合的に作用しながら、免疫機能を支えているのです。<br>
                ある特定の栄養素や食品に限定するのではなく、いろいろな食品から構成される栄養バランスのとれた食事を継続的にとり、免疫機能に関与する全ての栄養成分を摂取することが大切です。<br><br>

                　今回の「予防めし」は、継続して適正な食生活を送るための一助となるような食事例を具体的に伝えることを目的に2つの提案から構成します。<br>
                1つ目は、さまざまな栄養素を摂取できるように、「注目栄養素」を示し、その栄養素が豊富に含まれる料理とそのレシピを紹介します。<br>
                ２つ目は、その料理を組み込んだバランスの良い食事を管理栄養士・栄養士が提案します。<br>
            </p>
            <p v-if="pagename == 'movie'">
                日本栄養士会では「予防めし」レシピを<br class="hidePc">YouTubeでも配信しています。<br>
                管理栄養士・栄養士が実際に作る<br class="hidePc">栄養バランスの良い「予防めし」<br>
                動画をみながら家庭でも実践してみよう！
            </p>
            <div class="detail" v-if="pagename == 'about'">
                <div class="left-box">
                    <img src="@/assets/page/detail-img01.png" alt="">
                    <span class="credit">一品</span>
                </div>
                <div class="center-box">
                    <div class="word">
                        <span>PLUS</span>
                        <LineSound class="line left"/>
                        <LineSound class="line right"/>
                    </div>
                    <IconPlus class="plus" />
                </div>
                <div class="right-box">
                    <img src="@/assets/page/detail-img02.jpg" alt="">
                    <span class="credit">献立</span>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
import LogoYobo from '@/assets/logo-yobo.svg?inline'
import TextYobo from '@/assets/txt-yobo.svg?inline'
import LineSound from '@/assets/line-sound.svg?inline'
import IconPlus from '@/assets/icon-plus.svg?inline'

export default {
    name: 'page-koe',
    props:{
        pagename: String
    },
    components:{
        LogoYobo,
        TextYobo,
        LineSound,
        IconPlus
    },
    methods:{
        
    }
}
</script>

<style lang="scss" scoped>

.section{
    &.suggestion {
      padding-top: 200px;
      @media #{$maxM}{
        padding-top: 80px;
      }
    }
    .section-koe{
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        max-width: calc(896px - 40px);
        padding-bottom: 216px;
        padding-left: 20px;
        padding-right: 20px;
        @media #{$maxM}{
            padding-bottom: 180px;
        }
        &.full{
            max-width: calc(1020px - 40px);
            .col{
                @media #{$maxM}{
                    flex-flow: column;
                }
                .logo-wrap{
                    @media #{$maxM}{
                        padding-right: 0;
                        padding-bottom: 40px;
                        border-right: 0;
                        border-bottom: 2px solid $black;
                    }
                    .logo{
                        width: 186px;
                        height: 186px;
                        @media #{$maxM}{
                            width: 154px;
                            height: 154px;
                        }
                    }
                    .word{
                        width: 186px;
                        height: 15px;
                        @media #{$maxM}{
                            width: 154px;
                            height: 13px;
                        }
                    }
                }
                .text-box{
                    @media #{$maxM}{
                        padding-left: 0;
                        padding-top: 30px;
                    }
                    h5{
                        font-size: 3em;
                        @media only screen and (max-width: 1080px) {
                            font-size: 2.125em;
                        }
                        @media #{$maxM}{
                            font-size: 1.714em;
                            letter-spacing: 0.1em;
                            .hidePc{
                                display: none !important;
                            }
                        }
                    }                    
                }
            }
            p.left{
                max-width: 834px;
                text-indent: 1em;
                @media #{$maxM}{
                    max-width: 476px;
                }
                @media #{$IE}{
                  width: 100%;
                }
            }
        }
        h4{
            width: 100%;
            font-size: 1.25em;
            line-height: 2.2em;
            text-align: center;
            padding-bottom: calc(40px - 1.2em);
            border-bottom: 2px solid $black;
            max-width: 750px;
            @media #{$maxM}{
                padding-bottom: 20px;
            }
        }
        .col{
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-start;
            align-items: center;
            width: auto;
            padding-top: 35px;
            padding-bottom: 72px;
            @media #{$maxM}{
                align-items: stretch;
                padding-top: 20px;
                padding-bottom: 70px;
            }
                .logo-wrap{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    padding: 0 48px 0 22px;
                    border-right: 2px solid $black;
                    @media #{$maxM}{
                        padding: 0 20px 0 0;
                    }
                        .logo{
                            width: 164px;
                            height: 164px;
                            margin-bottom: 15px;
                            @media #{$maxM}{
                                width: 24vw;
                                height: 24vw;
                                margin-bottom: 8px;
                            }
                        }
                        .word{
                            width: 164px;
                            height: 14px;
                            @media #{$maxM}{
                                width: 24vw;
                                height: 7px;
                            }
                        }
                }
                .text-box{
                    padding-left: 24px;
                    @media #{$maxM}{
                        padding-left: 20px;
                    }
                        .caption{
                            font-family: $roboto;
                            font-weight: 600;
                            font-size: 0.875em;
                            margin-bottom: 20px;
                            @media #{$maxM}{
                                font-size: 10px;
                                margin-bottom: 14px;
                            }
                            &.for-about{
                                font-family: $default;
                                font-size: 1.125em;
                                margin-bottom: 24px;
                                line-height: 2.22em;
                            }
                        }
                        h5{
                            font-size: 2.125em;
                            line-height: 1.617em;
                            letter-spacing: 0.2em;
                            @media #{$maxM}{
                                font-size: 1.714em;
                                letter-spacing: 0.18em;
                            }
                            @media #{$maxM}{
                              font-size: 1.614em;
                            }
                        }
                }
        }
        p{
            font-family: $yugothic;
            font-weight: 500;
            text-align: center;
            font-size: 1.125em;
            line-height: 2.444em;
            letter-spacing: normal;
            @media #{$maxM}{
                line-height: 1.875em;
            }
            &.left{
                text-align: left;
            }
        }
        .detail{
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: stretch;
            width: 100%;
            margin-top: 100px;
            @media #{$maxM}{
                margin-top: 40px;
            }
            @media #{$IE}{
              @media screen and (max-width: 1100px) {
                flex-direction: column;
                margin-top: 120px;
              }
            }
            .left-box,
            .right-box{
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-flow: column;
                max-width: calc(50% - 2.5em - 40px);
                @media #{$maxM}{
                    max-width: calc(50% - 16px - 20px);
                }
                @media #{$IE}{
                  display: block;
                  text-align: center;
                  width: 385px;
                  img {
                    width: 385px;
                  }
                  @media screen and (max-width: 1100px) {
                    margin-top: 120px;
                    margin: 0 auto;
                  }
                  @media #{$maxM}{
                    width: 100%;
                    max-width: 275px;
                    img {
                      width: 275px;
                    }
                  }
                }
                    span.credit{
                        margin-top: 26px;
                        font-size: 1.25em;
                        @media #{$maxM}{
                            font-size: 1rem;
                            margin-top: 14px;
                        }
                        @media #{$IE}{
                          display: inline-block;
                        }
                    }
            }
            .center-box{
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                width: calc(62px + 26px + 2.5em);
                padding-left: 1.25em;
                padding-right: 1.25em;
                @media #{$maxM}{
                    width: 26px;
                    padding: 0;
                }
                @media #{$IE}{
                  @media screen and (max-width: 1100px) {
                    margin: 0 auto;
                    margin-top: 20px;
                  }
                }
                    .word{
                        font-family: $default;
                        font-size: 1.25em;
                        position: relative;
                        display: block;
                        text-align: center;
                        margin-bottom: 20px;
                        @media #{$maxM}{
                            font-size: 10px;
                            line-height: 1em;
                            margin-bottom: 10px;
                        }
                            .line{
                                position: absolute;
                                width: 13px;
                                height: 22px;
                                top: 0;
                                @media #{$maxM}{
                                    width: 6px;
                                    height: 10px;
                                }
                                &.left{
                                    transform: scaleX(-1);
                                    transform-origin: center;
                                    left: -1em;
                                    @media #{$maxM}{
                                        left: -8px;
                                    }
                                }
                                &.right{
                                    right: -1em;
                                    @media #{$maxM}{
                                        right: -8px;
                                    }
                                }
                            }
                    }
                    .plus{
                        height: 62px;
                        width: 62px;
                        @media #{$maxM}{
                            width: 26px;
                            height: 26px;
                            margin-bottom: calc(14px + 1rem);
                        }
                    }
            }
            .right-box{
                
                img{
                    transform: scale(0.94);
                } 
            }
        }
    }
}
</style>